'use strict';
//***********************************************************************************
//***********************************************************************************
//**** Build nomenclatures
//***********************************************************************************
//***********************************************************************************

import { cn_building } from '../../model/cn_building';
import { cn_nomenclature } from '../cn_nomenclature';

const POSITION_LABEL = new Map([
    ['floor', 'Sol'],
    ['ceiling', 'Plafond'],
    ['wall', 'Mur'],
    ['facade', 'Façade'],
    ['exterior', 'Extérieur']
])

//***********************************************************************************
//***********************************************************************************
/**
 * Buils facing's types  nomenclatures for the building
 * @param {cn_building} building
 * @returns {cn_nomenclature[]}
 */
export function cn_nomenclature_facing_types(building) {
    const output = [];

    output.push(new cn_nomenclature('ID').withVirtual(true));
    output.push(new cn_nomenclature('ASSOCIATED_IDS').withVirtual(true));
    output.push(new cn_nomenclature('Nom'));
    output.push(new cn_nomenclature('Position'));
    output.push(new cn_nomenclature('Surface totale').withNumberDefinition('m²', 2));

    const area_per_facing = new Map();
    const facing_segment_per_facing = new Map();

    building.storeys.forEach(storey => {
        storey.scene.storey = storey;
        storey.scene.update_deep();

        //*** We compute the storey volume */
        storey.build_facing_volume();

        storey.scene.spaces.forEach(space => {
            space.get_floor_facing_polygons().forEach(pg => {
                const facing = pg['facing_trimming'] ? pg['facing_trimming'].facing : space.facings[0];
                if (facing) {
                    area_per_facing.set(facing.ID, (area_per_facing.get(facing.ID) || 0) + pg.get_area());
                    facing_segment_per_facing.set(facing.ID, [...(facing_segment_per_facing.get(facing.ID) || []), cn_building.create_unique_id(storey, space, 'floor_facing', pg['facing_trimming'])]);
                }
            });
            if (space.has_roof && space.facings[1]) {
                const ceilings = space.get_3d_ceilings(storey);
                if (ceilings.length) {
                    area_per_facing.set(space.facings[1].ID, (area_per_facing.get(space.facings[1].ID) || 0) + ceilings.reduce((agg, ceiling) => agg + ceiling.get_area(), 0));
                    facing_segment_per_facing.set(space.facings[1].ID, [...(facing_segment_per_facing.get(space.facings[1].ID) || []), cn_building.create_unique_id(storey, space, 'ceiling')]);
                }
            }

            if (space.is_sub_face(storey) && space.facings[2]) {
                let area = 0;
                space.build_3d_sub_slab_polygons(storey).forEach(pg => area += pg.get_area());
                const facing = building.facing_types.find(f => space.facings[2] && space.facings[2].ID === f.ID);
                area_per_facing.set(space.facings[2].ID, (area_per_facing.get(space.facings[2].ID) || 0) + area);
                facing_segment_per_facing.set(space.facings[2].ID, [...(facing_segment_per_facing.get(space.facings[2].ID) || []), cn_building.create_unique_id(storey, space, 'sub_slab_facing')]);
            }

            space.space_segments.forEach(sslist => {
                sslist.forEach(ss => {
                    ss.build_facing_polygons(storey).forEach(pg => {
                        const facing = pg['facing_trimming'] ? pg['facing_trimming'].facing : ss.facing;
                        if (facing) {
                            area_per_facing.set(facing.ID, (area_per_facing.get(facing.ID) || 0) + pg.get_area());
                            facing_segment_per_facing.set(facing.ID, [...(facing_segment_per_facing.get(facing.ID) || []), pg['bbp_id']]);
                        }
                    });
                });
            });
        });

    });

    const max_layers = Math.max(...building.facing_types.map(ft => ft.facing_layers.length))

    for (let i = 1; i <= max_layers; i++) {
        const visibility = i <= 3;
        const nomenclatureName = new cn_nomenclature('Couche ' + i).withVisibility(visibility);
        nomenclatureName.values = Array(building.facing_types.length).fill('');
        output.push(nomenclatureName);
        const nomenclatureThickness = new cn_nomenclature('Épaisseur couche ' + i).withNumberDefinition('cm', 2).withVisibility(visibility);
        nomenclatureThickness.values = Array(building.facing_types.length).fill('');
        output.push(nomenclatureThickness);
    }

    building.facing_types.forEach((facing_type, i) => {

        let nomenclature_entry_index = 0;
        output[nomenclature_entry_index].values[i] = facing_type.ID;
        nomenclature_entry_index++;
        output[nomenclature_entry_index].values[i] = facing_segment_per_facing.get(facing_type.ID);
        nomenclature_entry_index++;
        output[nomenclature_entry_index].values[i] = facing_type.name;
        nomenclature_entry_index++;
        output[nomenclature_entry_index].values[i] = POSITION_LABEL.get(facing_type.support);
        nomenclature_entry_index++;
        output[nomenclature_entry_index].values[i] = area_per_facing.get(facing_type.ID) || 0;
        nomenclature_entry_index++;
        facing_type.facing_layers.forEach(fl => {
            output[nomenclature_entry_index].values[i] = fl.get_name_label();
            nomenclature_entry_index++;
            output[nomenclature_entry_index].values[i] = fl.thickness * 100;
            nomenclature_entry_index++;
        })
    });

    return output;
}
